import {
    getRouteIdDPStartLoading,
    getRouteIdDPStartRequest,
    getRouteIdDPStartSuccess,
    getRouteIdDPStartReject,
} from "../../actions/route/getDPStartAll";

export const getRouteIdDPStart = (formData) => async (dispatch, getState) => {
    dispatch(getRouteIdDPStartLoading());
    try {
        const { data } = await getRouteIdDPStartRequest(formData, getState);
        dispatch(getRouteIdDPStartSuccess(data))
    } catch (error) {
        dispatch(getRouteIdDPStartReject(error))
    }
    return Promise.resolve();
};